//Generated File 
export default class WidgetState{
	static readonly Disabled = `Disabled`;
	static readonly Enabled = `Enabled`;
	static readonly Invisible = `Invisible`;
}
